import { z } from "zod";

export const CourierSchema = z.object({
  courier_content_type: z.string(),
  courier_object_id: z.number(),
});
